import { ReactElement, useMemo, useCallback, memo } from 'react';
import { Button } from '@mui/material';
import { compact } from 'lodash';

import { useOrdersFilterMenuGiverContext } from '../Context';
import { OrdersFilterMenuGiverActionsContainer } from '../styles';

const OrdersFilterMenuGiverActions = (): ReactElement => {
  const {
    currentFilters: { filters, activeFilters, onApplyFilters, onClearFilters },
    handleManualClose,
  } = useOrdersFilterMenuGiverContext();

  const isValidToApply = useMemo(
    () => !(JSON.stringify(filters) === JSON.stringify(activeFilters)),
    [filters, activeFilters],
  );

  const handleApplyFilter = useCallback(() => {
    onApplyFilters();

    handleManualClose();
  }, [onApplyFilters, handleManualClose]);

  const isEmptyFilters = useMemo(() => {
    const currentFilters = [
      filters.search,
      filters.expirationDateTimeFrom,
      filters.expirationDateTimeTo,
      filters.includeWithoutExpirationDate?.toString(),
      filters.finalizedDateTimeFrom,
      filters.finalizedDateTimeTo,
      filters.itemState?.toString(),
      // filters.collectState?.toString(),
    ];

    const compactCurrentFilters = compact(currentFilters);

    return compactCurrentFilters.length === 0;
  }, [filters]);

  return (
    <OrdersFilterMenuGiverActionsContainer>
      <Button
        variant="contained"
        color="primary"
        onClick={handleApplyFilter}
        disabled={!isValidToApply}
        fullWidth
      >
        Aplicar
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        onClick={onClearFilters}
        disabled={isEmptyFilters}
        fullWidth
      >
        Borrar Filtros
      </Button>
    </OrdersFilterMenuGiverActionsContainer>
  );
};

export default memo(OrdersFilterMenuGiverActions);
